import React from 'react';

import Layout from './layout';

import './App.scss';

const App = () => {
  return (
    <Layout />
  );
}

export default App;
